import drawImageSync from "./drawImage.js";
import { getDefaultViewport } from "component/molecules/viewport/ViewportConfig";
/**
 * creates a dummy enabled element
 *
 * @param {HTMLCanvasElement} canvas the canvas that will be assigned to the enabled element.
 * @param {any} image An Image loaded by a  Image Loader
 * @param { any } options Options for rendering the image (e.g.enable webgl by {renderer: 'webgl' })
 * @param { any } viewport A set of  viewport parameters
 * @returns {EnabledElementStub} a dummy enabled element
 * @memberof rendering
 */
function createEnabledElementStub(canvas, image, imageIdx, uuid, viewport) {
  return {
    element: canvas,
    canvas,
    image,
    imageIdx,
    invalid: true, // True if image needs to be drawn, false if not
    needsRedraw: true,
    uuid: uuid,
    layers: [],
    data: {},
    renderingTools: {},
    viewport,
    isDataChanging: false,
  };
}

/**
 * Render the image to the provided canvas immediately.
 * @param {any} canvas The HTML canvas where the image will be rendered.
 * @param {any} image An Image loaded by a  Image Loader
 * @param {any} [viewport = null] A set of  viewport parameters
 * @param {any} [options = null] Options for rendering the image (e.g. enable webgl by {renderer: 'webgl'})
 * @returns {void}
 * @memberof rendering
 */
//export default function (canvas, image, viewport = null, options = null) {
export default function (
  canvas,
  image,
  viewport = null,
  uuid = null,
  imageIdx = 0
) {
  if (canvas === undefined) {
    throw new Error("renderToCanvas: parameter canvas cannot be undefined");
  }

  let defaultViewport = null;
  if (viewport === null) {
    defaultViewport = getDefaultViewport(canvas, image);
  } else {
    if (!(viewport.voi === undefined)) {
      if (viewport.voi.windowWidth === undefined) {
        defaultViewport = getDefaultViewport(canvas, image);
      } else {
        defaultViewport = viewport;
      }
    }
  }

  /**
   * @FIXME 아래 코드는 추후 삭제 하고, DCMView와 연결되는 Element 관리 개체 생성 함수를 별도로 생성하는 함수추가
   */
  const enabledElementStub = createEnabledElementStub(
    canvas,
    image,
    imageIdx,
    uuid,
    defaultViewport
  );

  drawImageSync(enabledElementStub, image, enabledElementStub.invalid);

  //return enabledElementStub.viewport;
  return enabledElementStub;
}
